<dx-popup
    #vendorNotesPopup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="50%"
    title="Notes For Vendor {{ vendorName }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onVendorNotesPopClose()"
>
    <div *dxTemplate="let data of 'content'">
        <app-notes-viewer
            #vendorNotes
            [previousNotes]="previousVendorNotes"
            (notesPopUpClose)="onVendorNotesPopClose()"
        ></app-notes-viewer>
    </div>
</dx-popup>
